import {InputTextarea} from "primereact/inputtextarea";
import {useEffect, useState} from "react";

export default function InputTextAreaField({
    id,
    ref,
    value,
    border,
    className,
    hasAssociatedOutput,
    disabled,
    placeholder,
    cols,
    rows,
    onChange,
    onBlur,
}) {
    const [localValue, setLocalValue] = useState(value);

    useEffect(() => {
        setLocalValue(value);
    }, [value]);

    const blurHandler = (e) => {
        if (typeof onBlur === "function") {
            onBlur(e);
        }
        if (e.target.value === value) {
            return;
        }
        return onChange(e);
    };
    const changeHandler = (e) => {
        setLocalValue(e.target.value || null);
    };
    return (
        <InputTextarea
            id={id}
            ref={ref}
            className={`w-full rounded-border ${border} ${className} indication-filled-placeholder`}
            value={localValue || ""}
            disabled={disabled}
            onChange={changeHandler}
            onBlur={blurHandler}
            placeholder={placeholder}
            autoResize={true}
            cols={cols ? cols : 5}
            rows={rows ? rows : 3}
            maxLength={4096}
        />
    );
}
